'use client'

import { ToolLandingTemplate } from '../_components/tool-landing-template'
import { ai_email_template_generatorConfig } from './config'
import type { User } from '@/lib/types'

interface AiEmailTemplateGeneratorClientProps {
  user: User | null
  userApiKey: string
}

export default function AiEmailTemplateGeneratorClient({
  user,
  userApiKey,
}: AiEmailTemplateGeneratorClientProps) {
  return (
    <ToolLandingTemplate
      user={user}
      config={ai_email_template_generatorConfig}
    />
  )
}
